module.exports = __webpack_public_path__ + "img/SIP_logo.fa5dfe50.png";